
import React from "react";
import "./grade.sass";
import { Input, Dropdown, RadioOption, RadioGroup, DropdownOption, LoadingIndicator } from '@abb/abb-common-ux-react';
import { ICalculatedPropertyViewData } from "../../models/property/CalculatedPropertyViewData";
import IReading from "../../models/property/ReadingData";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";

interface IAssociateCalculatedProperties {
    isShowButton?: boolean;
    disableValueDropdown: boolean;
    disablePositionDropdown: boolean;
    disableSourceDropdown: boolean;
    propertyData?: any;
    details: ICalculatedPropertyViewData[];
    sourceList: any[];
    valuesList: any[];
    newList: any[];
    partitionList: any[];
    oldPartitionList?: any[];
    sourceChangeHandler?: (data: any, index: number, i: number, calculatedId: string) => void;
    valuesChangeHandler?: (data: any, index: number, i: number, calculatedId: string) => void;
    partitionChangeHandler?: (data: any, index: number, i: number, calculatedId: string, selectedElement: any) => void;
    onEditPartitionChange?: (data: any, index: number, i: number, calculatedId: string) => void;
    onToggleClick?: (data: any, index: number, i: number, calculatedId: string) => void;
    onCloseAll?: (e: any) => void;
    isLoading?: boolean;
    optionRef?: any;
    componentType?: string;
    instrumentPartitions?: any[];
    keyedInPartitions?: any[];
    measuredProperty?: any[];
}

interface IAssociatedCalculatedState {
}

export default class AssociateCalculatedProperty extends React.Component<
    IAssociateCalculatedProperties,
    IAssociatedCalculatedState
> {
    constructor(props: any) {
        super(props)
    }

    public positionData = (row: any) => {
        let measuredPositionData: any = []
        let keyedInPositionData: any = []
        keyedInPositionData = this.props.keyedInPartitions?.filter((x: any) => x.id === row.property.id)
        const measuredData = this.props.measuredProperty?.filter((x: any) => x.propertyId === row.property.id)
        measuredData?.map((z: any) => {
            measuredPositionData = this.props.instrumentPartitions?.filter((x: any) => x.id === z.instrumentId)
        })
        const positionListData: any[] = [];
        if (keyedInPositionData?.length !== 0) {
            keyedInPositionData[0]?.partitions?.forEach(
                (element: any, index: number) => {
                    positionListData.push({
                        value: index,
                        label: element.name,
                    });
                }
            );
        } else {
            measuredPositionData[0]?.partitions?.forEach(
                (element: any, index: number) => {
                    positionListData.push({
                        value: index,
                        label: element.name,
                    });
                }
            );
        }
        return positionListData
    }

    public render() {
        return (
            <Translation>
                {
                    t =>
                        <div className="head ml-4">
                            <div className="font-weight-bold mt-1">{t(CONSTANTS.FORMULA_DEFINITION)}</div>
                            {this.props.details?.map((item, index) => {
                                return <div key={index} >
                                    <table className="tbl-edit">
                                        <thead>
                                            <tr>
                                                <th className="table-title" style={{}}>{t(CONSTANTS.MENU_PROPERTY)}:</th>
                                                <th className="table-title" style={{ paddingLeft: "50px" }}>{t(CONSTANTS.FORMULA)}:</th>
                                            </tr>
                                            <tr>
                                                <td className="mr-1" style={{ background: "none" }}>{item.name}</td>
                                                <td className="" style={{ paddingLeft: "45px", background: "none" }}>{item.formula}</td>
                                            </tr>
                                            <tr>
                                                <th className="table-title" style={{}}>{t(CONSTANTS.INPUT_DEFINITION)}:</th>
                                            </tr>
                                            <tr>
                                                <th className="table-title text-uppercase px-3" style={{ width: "10%" }}>{t(CONSTANTS.LABEL_VARIABLE)}</th>
                                                <th className="table-title text-uppercase" style={{ width: "10%" }}>{t(CONSTANTS.LABEL_PROPERTYID)}</th>
                                                <th className="table-title text-uppercase" style={{ width: "10%" }}>{t(CONSTANTS.MENU_PROPERTY)}</th>
                                                <th className="table-title text-uppercase" style={{ width: "10%" }}>{t(CONSTANTS.LABEL_PROPERTY_ATTRIBUTE)}</th>
                                                <th className="table-title text-uppercase" style={{ width: "10%" }}>{t(CONSTANTS.LABEL_SERIES)}</th>
                                                <th className="table-title text-uppercase" style={{ width: "10%" }}></th>
                                                <th className="table-title text-uppercase" style={{ width: "10%" }}>{t(CONSTANTS.LABEL_VALUE)}</th>
                                            </tr>
                                            {item.variables.map((row, i) => {
                                                let positionListData;
                                                if(this.props.componentType){
                                                    positionListData = this.positionData(row)
                                                }
                                                return <tr key={i} >
                                                    <td>
                                                        <Input
                                                            disabled={true}
                                                            className="disable-color"
                                                            dataType="text"
                                                            indicateChanged={false}
                                                            value={row.variable}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Input
                                                            disabled={true}
                                                            className="disable-color"
                                                            dataType="text"
                                                            indicateChanged={false}
                                                            value={row.property.customId}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Input
                                                            disabled={true}
                                                            className="disable-color"
                                                            dataType="text"
                                                            indicateChanged={false}
                                                            value={row.property.name}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Input
                                                            disabled={true}
                                                            className="disable-color"
                                                            dataType="text"
                                                            indicateChanged={false}
                                                            value={t(row.attribute.name)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <div className="double-dropdown-1">
                                                            <Dropdown
                                                                disabled={row.disableSource}
                                                                className={row.disableSource ? "disable-background" : ""}
                                                                placeholder={t(CONSTANTS.LABEL_PICK_SOURCE)}
                                                                value={row.selectedSource}
                                                                // tslint:disable-next-line: jsx-no-lambda
                                                                onChange={(value) => this.props.sourceChangeHandler(value, index, i, item.id)}>
                                                                {this.props.sourceList.map(o => (
                                                                    <DropdownOption key={o.value} label={o.label} value={o.value} />
                                                                ))}
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                    {this.props.componentType ? (
                                                        <td>
                                                            <div className="double-dropdown-2 select">
                                                                <div className={row.disablePosition ? "dropdown-container dropdown-disabled-li" : "dropdown-container"} >
                                                                    <div className="dropdown-header-dt"
                                                                        onClick={row.disablePosition ? undefined : (e) => this.props.onToggleClick(e, index, i, item.id)}
                                                                    >
                                                                        {row.selectedPosition || <span>{t(CONSTANTS.LABEL_PICK_POSITION)}</span>}
                                                                    </div>
                                                                    {row.isSelected && (
                                                                        <div className="dropdown-list-container" ref={this.props.optionRef}>
                                                                            {this.props.isLoading ?
                                                                                <LoadingIndicator
                                                                                    determinate={false}
                                                                                    type="radial" sizeClass="small" color="blue" />
                                                                                : <ul className={positionListData.length > 5 ? "dropdown-ul overflow-y-position" : "dropdown-ul"}>
                                                                                    {positionListData.map((o, indx) => (
                                                                                        <li
                                                                                            className={o.disabled ? 'd-none dropdown-li' : "dropdown-li"}
                                                                                            onClick={(e) => this.props.partitionChangeHandler(e, index, i, item.id, o)}
                                                                                            key={Math.random()}>
                                                                                            <span>{o.label}</span>
                                                                                        </li>
                                                                                    ))}
                                                                                </ul>}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </td>
                                                    ) : (<td>
                                                        <div className="double-dropdown-2 select">
                                                            <div className={row.disablePosition ? "dropdown-container dropdown-disabled-li" : "dropdown-container"} >
                                                                <div className="dropdown-header-dt"
                                                                    onClick={row.disablePosition ? undefined : (e) => this.props.onToggleClick(e, index, i, item.id)}
                                                                >
                                                                    {row.selectedPosition || <span>{t(CONSTANTS.LABEL_PICK_POSITION)}</span>}
                                                                </div>
                                                                {row.isSelected && (
                                                                    <div className="dropdown-list-container" ref={this.props.optionRef}>
                                                                        {this.props.isLoading ?
                                                                            <LoadingIndicator
                                                                                determinate={false}
                                                                                type="radial" sizeClass="small" color="blue" />
                                                                            : <ul className={this.props.partitionList.length > 5 ? "dropdown-ul overflow-y-position" : "dropdown-ul"}>
                                                                                {this.props.partitionList.map((o, indx) => (
                                                                                    <li
                                                                                        className={o.disabled ? 'd-none dropdown-li' : "dropdown-li"}
                                                                                        onClick={(e) => this.props.partitionChangeHandler(e, index, i, item.id, o)}
                                                                                        key={Math.random()}>
                                                                                        <span>{o.label}</span>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </td>)}
                                                    <td>
                                                        {row.disableValue ?
                                                            <Dropdown
                                                                disabled={row.disableValue}
                                                                className={row.disableValue ? "disable-background" : ""}
                                                                placeholder={t(CONSTANTS.LABEL_PICK) + " " + t(CONSTANTS.LABEL_VALUE)}
                                                                value={row.selectedValue}
                                                                // tslint:disable-next-line: jsx-no-lambda
                                                                onChange={(value) => this.props.valuesChangeHandler(value, index, i, item.id)}>
                                                                {this.props.valuesList.map((o: any) => {
                                                                    return <DropdownOption key={o.value} label={t(o.label)}
                                                                        value={o.value} />
                                                                })}
                                                            </Dropdown> :
                                                            <Dropdown
                                                                disabled={row.disableValue}
                                                                className={row.disableValue ? "disable-background" : ""}
                                                                allowAdd={false}
                                                                placeholder={t(CONSTANTS.LABEL_PICK) + " " + t(CONSTANTS.LABEL_VALUE)}
                                                                value={row.selectedValue}
                                                                // tslint:disable-next-line: jsx-no-lambda
                                                                onChange={(value) => this.props.valuesChangeHandler(value, index, i, item.id)}>
                                                                {this.props.newList.map((o: any) => {
                                                                    return <DropdownOption key={o.value} label={t(o.label)}
                                                                        value={o.value} />
                                                                })}
                                                            </Dropdown>}
                                                    </td>
                                                </tr>
                                            })}
                                        </thead>
                                    </table>
                                    <p className="table-title mt-2"> {t(CONSTANTS.LABEL_FORMULA_EXECUTION)}:</p>
                                    <div className="margins">
                                        <RadioGroup
                                            sizeClass={"small"}
                                            value="series"
                                            orientation={'horizontal'}
                                        >
                                            <RadioOption text={t(CONSTANTS.LABEL_SERIE)} value={"series"} />

                                        </RadioGroup>
                                    </div>
                                </div>

                            })}

                        </div>
                }
            </Translation>
        )
    }
}